import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const engagementRateFollowersConfig = {
    name: 'kpi.facebook.page_followers_engagement_rate',
    id: 'engagement_rate_followers',
    icon: {
        name: 'engagement-on',
        style: colors.purple
    },
    mergedData: true,
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    tooltip: 'kpi.facebook.tooltip_engagement_rate',
    data_format: KPI_VALUE_PERCENT,
    size: SIZE_33,
    type: 'kpi',
    element: KPIDefault,
    loader: DefaultLoader
};
